/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Choose_RunInputs */

const bn_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুরু করার জন্য একটি দৌড় চয়ন করুন।`)
};

const de_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Lauf aus, mit dem Sie beginnen möchten.`)
};

const el_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε ένα τρέξιμο για να ξεκινήσετε.`)
};

const en_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a run to begin.`)
};

const es_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una carrera para comenzar.`)
};

const fr_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une partie pour commencer.`)
};

const hi_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू करने के लिए एक दौड़ चुनें.`)
};

const hu_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kezdéshez válasszon egy futást.`)
};

const id_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih lari untuk memulai.`)
};

const it_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una corsa per iniziare.`)
};

const ja_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始する実行を選択します。`)
};

const ko_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시작하려면 달리기를 선택하세요.`)
};

const nl_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een hardloopsessie om te beginnen.`)
};

const pl_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz bieg, aby rozpocząć.`)
};

const pt_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma corrida para começar.`)
};

const ru_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите прогон, чтобы начать.`)
};

const sv_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj en löprunda att börja.`)
};

const tr_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlamak için bir koşu seçin.`)
};

const uk_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть пробіжку для початку.`)
};

const vi_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một cuộc chạy để bắt đầu.`)
};

const zh_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要开始的跑步。`)
};

const zh_hant_game_choose_run = /** @type {(inputs: Game_Choose_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇要開始的跑步。`)
};

/**
* | output |
* | --- |
* | "Choose a run to begin." |
*
* @param {Game_Choose_RunInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_choose_run = /** @type {((inputs?: Game_Choose_RunInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Choose_RunInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_choose_run(inputs)
	if (locale === "de") return de_game_choose_run(inputs)
	if (locale === "el") return el_game_choose_run(inputs)
	if (locale === "en") return en_game_choose_run(inputs)
	if (locale === "es") return es_game_choose_run(inputs)
	if (locale === "fr") return fr_game_choose_run(inputs)
	if (locale === "hi") return hi_game_choose_run(inputs)
	if (locale === "hu") return hu_game_choose_run(inputs)
	if (locale === "id") return id_game_choose_run(inputs)
	if (locale === "it") return it_game_choose_run(inputs)
	if (locale === "ja") return ja_game_choose_run(inputs)
	if (locale === "ko") return ko_game_choose_run(inputs)
	if (locale === "nl") return nl_game_choose_run(inputs)
	if (locale === "pl") return pl_game_choose_run(inputs)
	if (locale === "pt") return pt_game_choose_run(inputs)
	if (locale === "ru") return ru_game_choose_run(inputs)
	if (locale === "sv") return sv_game_choose_run(inputs)
	if (locale === "tr") return tr_game_choose_run(inputs)
	if (locale === "uk") return uk_game_choose_run(inputs)
	if (locale === "vi") return vi_game_choose_run(inputs)
	if (locale === "zh") return zh_game_choose_run(inputs)
	return zh_hant_game_choose_run(inputs)
});